// extracted by mini-css-extract-plugin
export default {"ctnInfo":"LeftContact_ctnInfo__lq+Wp"};